import { Component, Input, OnInit, EventEmitter, Output, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { DropdownMultiselectItem } from '@bayclubs/drop-down';
import { TranslateService } from '@ngx-translate/core';

import { campsenum } from '../../../models/enums.generated';
import { camps } from '../../../models/models.generated';
import { SelectedMember } from '../../../models/filters/selected-member.model';
import { FilterDropDownsService } from '../../../services/filter-dropdowns.service';
import { PurchaseListFilter } from '../../../models/filters/purchase-list-filter.model';

@Component({
    selector: 'app-purchase-search-criteria',
    templateUrl: './purchase-search-criteria.component.html',
    styleUrls: ['./purchase-search-criteria.component.scss'],
    standalone: false
})
export class PurchaseSearchCriteriaComponent implements OnInit {
    @Input()
    public searchForm: UntypedFormGroup;

    @Input()
    public filteredMember: SelectedMember;

    @Input()
    public filters: PurchaseListFilter;

    @Output() public membershipSelected: EventEmitter<SelectedMember> = new EventEmitter<SelectedMember>();

    currentMember: SelectedMember;

    public campTypeDropdownItems: DropdownMultiselectItem[] = [];

    constructor(private filterDropDownsService: FilterDropDownsService) { }

    ngOnInit() {
        this.campTypeDropdownItems = this.filterDropDownsService.createCampTypeDropDownItems(this.filters.campTypes);
    }

    public onMembershipSelected(item: camps.MembershipInfo) {
        if (item) {
            this.searchForm.controls['membershipId'].setValue(item.membershipId);
        } else {
            this.searchForm.controls['membershipId'].setValue(null);
        }

        if (item) {
            this.membershipSelected.emit({
                mainMember: item.mainMember,
                mainMemberId: item.mainMemberId,
                membershipId: item.membershipId,
                children: []
            } as SelectedMember);
        } else {
            this.membershipSelected.emit(null);
        }


    }

    showNumberClear() {
        return this.searchForm.controls['purchaseNumber'].value;
    }

    onNumberClear() {
        this.searchForm.controls['purchaseNumber'].setValue(null);
    }


    ngOnChanges(changes: SimpleChanges) {
        if (changes['filteredMember']) {
            this.currentMember = this.filteredMember;
        }
    }

    public onCampTypeChanged(data: Array<DropdownMultiselectItem>) {
        const campTypes = data.map(x => x.id);
        this.searchForm.controls['campTypes'].setValue(campTypes);
    }
}
